import React from 'react';
import { Navigate } from 'react-router-dom';
import { ComplextRoute } from 'router/components/Routes/Routes';
import Login from 'router/subrouters/Auth/pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import SignUp from './pages/SignUp';
import SocialLogin from './pages/SocialLogin';
import TwoFactorAuthentication from './pages/TwoFactorAuthentication/TwoFactorAuthentication.page';

export default [
  {
    path: 'login',
    element: Login,
  },
  {
    path: 'sign-up',
    element: SignUp,
  },
  {
    path: 'social-login',
    element: SocialLogin,
  },
  {
    path: 'forgot-password',
    element: ForgotPassword,
  },
  {
    path: 'reset-password',
    element: ResetPassword,
  },
  {
    path: '2-fa',
    element: TwoFactorAuthentication,
  },
  {
    index: true,
    element: <Navigate to="login" replace />,
  },
] as Array<ComplextRoute>;
